import {
  FormsFiltersClient,
  FormsFiltersServer,
} from '../../types/RequestMain';

export function mapFormsFiltersToAPI({
  view,
  name,
  dateFrom,
  dateTo,
  regNum1C,
  regNumLK,
}: FormsFiltersClient): FormsFiltersServer {
  return {
    filter_applicant_name: name,
    filter_form_kind: view,
    filter_request_sent_from: dateFrom,
    filter_request_sent_to: dateTo,
    filter_request_number: regNumLK,
    filter_request_bps_number: regNum1C,
  };
}
